<template>
  <div class="leave-form-wrap">
    <!-- 申请详情列表 -->
    <div class="form-wrap" v-for="(item, index) in list" :key="index">
      <div class="form_wrap_item">
        <div class="form_wrap_item_con-title">
          <van-radio-group
            v-model="item.isAudit"
            direction="horizontal"
            v-if="(type == 'au' || type == 'user') && item.auditStatus == 0"
          >
            <van-radio
              @click="handleRadio(true, item.id)"
              name="0"
              :disabled="type == 'au' || type == 'user' ? false : true"
              checked-color="#1989fa"
              >通过</van-radio
            >
            <van-radio
              @click="handleRadio(false, item.id)"
              name="1"
              :disabled="type == 'au' || type == 'user' ? false : true"
              checked-color="#ee0a24"
              >驳回</van-radio
            >
          </van-radio-group>
          <div>
            <span
              v-if="
                type == 'list' ||
                (type == 'au' &&
                  (item.auditStatus == 1 || item.auditStatus == 2)) ||
                (type == 'user' &&
                  (item.auditStatus == 1 || item.auditStatus == 2))
              "
              >审批状态 :
            </span>
            <van-tag
              plain
              type="primary"
              size="medium"
              v-if="item.auditStatus == 0"
              >待审批</van-tag
            >
            <van-tag
              plain
              type="success"
              size="medium"
              v-if="item.auditStatus == 1"
              >已审批</van-tag
            >
            <van-tag
              plain
              type="danger"
              size="medium"
              v-if="item.auditStatus == 2"
              >已驳回</van-tag
            >
          </div>

          <!-- <van-tag plain type="primary" size="medium" v-if="item.auditStatus == 0">待审批</van-tag>
          <van-tag plain type="success" size="medium" v-if="item.auditStatus == 1">已审批</van-tag> -->
        </div>
        <div class="form_wrap_item_con">
          <span>姓名 :</span>
          <span class="info_span">{{ item.userName }}</span>
        </div>
        <div class="form_wrap_item_con">
          <span>部门 :</span>
          <span class="info_span">{{ item.deptName }}</span>
        </div>
        <div class="form_wrap_item_con">
          <span>出入事由 :</span>
          <span class="info_span">{{ item.reason }}</span>
        </div>
        <div class="form_wrap_item_con">
          <span>出校时间段 :</span>
          <span class="info_span">{{ item.outTime }}</span>
        </div>
        <div class="form_wrap_item_con">
          <span>入校时间段 :</span>
          <span class="info_span">{{ item.inTime }}</span>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="title">出入校审批信息</div>
      <div class="panel">
        <van-steps direction="vertical" :active="2" active-color="#1989fa">
          <!-- <van-step>
            <div>
              <span style="margin-right: 0.5rem">刘强</span>
              <van-tag plain type="success" size="medium">已审批</van-tag>
            </div>
            <div style="color: #999; margin-top: 0.5rem">
              <span>时间：</span>2022-04-08 22:00
            </div>
          </van-step> -->
          <van-step v-for="item in auditList" :key="item.id">
            <div>
              <span style="margin-right: 0.5rem">{{ item.auditName }}</span>

              <van-tag
                plain
                type="primary"
                size="medium"
                v-if="item.auditStatus == 0"
                >待审批</van-tag
              >
              <van-tag
                plain
                type="success"
                size="medium"
                v-if="item.auditStatus == 1"
                >已审批</van-tag
              >
              <van-tag
                plain
                type="danger"
                size="medium"
                v-if="item.auditStatus == 2"
                >已驳回</van-tag
              >
            </div>
            <div style="color: #999; margin-top: 0.5rem" v-if="item.auditTime">
              <span>时间：</span>{{ setTime(item.auditTime) }}
            </div>
            <div
              style="color: #999; margin-top: 0.5rem"
              v-if="item.auditRemark"
            >
              <span>备注: </span>{{ item.auditRemark }}
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>
    <!-- 通过以及驳回按钮 -->
    <div class="handle_btn">
      <!-- <van-button style="color: #000; background-color: #e3e3e3" round>
        驳回
      </van-button> -->
      <van-button
        round
        type="info"
        v-if="(type == 'au' || type == 'user') && isShowAuditBtn"
        native-type="submit"
        @click="setShowNextAudit"
      >
        审核
      </van-button>
      <van-button
        round
        type="info"
        v-if="type == 'list'"
        native-type="submit"
        @click="back"
      >
        返回
      </van-button>
    </div>

    <!-- 温馨提示弹窗 -->
    <van-dialog
      v-model="show"
      show-cancel-button
      close-on-click-overlay
      :confirm-button-text="isShowNextAudit2 ? '通过' : '审核'"
      @cancel="cancel"
      title="温馨提示"
      @confirm="confirm"
    >
      <div class="dialog-wrap">
        <div style="text-align: center">
          {{ isShowNextAudit2 ? dialogMsg : "审核后不可更改" }}
        </div>
        <div>
          <div class="dialog-item-title">备注</div>
          <input
            type="text"
            class="cell-wrap"
            placeholder="备注"
            v-model="remark"
          />
          <div v-if="isShowNextAudit">
            <div class="dialog-item-title">选择下一位审批人</div>
            <div
              class="cell-wrap"
              @click="$refs.interviewee.showiIntervieweePopup = true"
            >
              {{ pickerItem.deptName || "" }} {{ pickerItem.name || "" }}
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <Interviewee
      ref="interviewee"
      @selectItem="handleSelIntervieweeItem"
      pageType="teacher"
    />
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      radio: "0",
      show: false,
      remark: "",
      dialogMsg: "是否审核通过?",
      list: [],
      // 审核id数组
      auditIdList: [],
      auditList: [],
      audit: "",
      pickerItem: {},
      // 是否显示审核按钮
      isShowAuditBtn: false,
      isShowNextAudit: true,
      isShowNextAudit2: true,
      // 根据学校设置最终审批人
      // finalAuditList: 
    };
  },
  components: {
    Interviewee: () => import("@/components/subScribePopup/interviewee.vue"),
  },
  computed: {
    type() {
      return this.$route.query.type;
    },
    id() {
      return this.$route.query.id;
    },
  },
  mounted() {
    this.getAuditDetail();
  },
  methods: {
    setShowNextAudit() {
      this.isShowNextAudit = this.auditIdList.length != 0;

      if (this.isShowNextAudit) {
        this.isShowNextAudit2 = true;
        // 判断是否为最终审批人
        this.test();
      } else {
        this.isShowNextAudit2 = false;
        this.pickerItem = {};
      }

      this.show = true;
    },

    changeSchoolAudit() {},

    // 设置默认审批人
    test() {
      // 判断学校设置最终审核人
      let schoolId = JSON.parse(localStorage.getItem("userInfo")).schoolId;
      let schoolName = JSON.parse(localStorage.getItem("userInfo")).schoolName;
      if (schoolId == "1070770900580810752" && schoolName == "济南亚爱特软件") {
        // 设置最终审核人为张丽宝
        if (
          JSON.parse(localStorage.getItem("userInfo")).id ==
          "1070871374333460480"
        ) {
          this.isShowNextAudit = false;
          this.pickerItem = {};
        } else {
          this.isShowNextAudit = true;
          this.pickerItem = {
            deptName: "政府事业部",
            id: "1070871374333460480",
            info: "张丽宝-政府事业部",
            name: "张丽宝",
          };
        }
      } else if (
        schoolId == "1271662703250526208" &&
        schoolName == "济南幼儿师范高等专科学校"
      ) {
        // 设置最终审核人为张海平
        if (
          JSON.parse(localStorage.getItem("userInfo")).id ==
          "1272272025873567744"
        ) {
          this.isShowNextAudit = false;
          this.pickerItem = {};
        } else {
          this.isShowNextAudit = true;
          this.pickerItem = {
            deptName: "网络管理中心",
            id: "1272272025873567744",
            info: "夏伯慷-网络管理中心",
            name: "夏伯慷",
          };
        }
      }
    },
    setTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    // 列表清单进行时间格式化
    setInAndTime(data) {
      let obj = data;
      for (let item of obj) {
        item.isAudit = "0";
        if (item.auditStatus != 2) {
          this.auditIdList.push(item.id);
        }

        if (item.inBeginTime != null && item.inEndTime != null) {
          item.inTime =
            moment(item.inBeginTime).format("YYYY-MM-DD HH:mm") +
            "-" +
            moment(item.inEndTime).format("YYYY-MM-DD HH:mm").slice(11);
        }
        if (item.outBeginTime != null && item.outEndTime != null) {
          item.outTime =
            moment(item.outBeginTime).format("YYYY-MM-DD HH:mm") +
            "-" +
            moment(item.outEndTime).format("YYYY-MM-DD HH:mm").slice(11);
        }
        console.log("出校和入校时间段", item);
      }
      console.log("obj", obj);
      return obj;
    },
    handleRadio(isSave, id) {
      if (isSave) {
        if (!this.auditIdList.includes(id)) {
          this.auditIdList.push(id);
        }
      } else {
        if (this.auditIdList.includes(id)) {
          let idNum = this.auditIdList.findIndex((item) => item == id);
          this.auditIdList.splice(idNum, 1);
          // 删除指定的值
        }
      }
    },
    // 获取审核详情
    getAuditDetail() {
      let id = this.id;

      if (this.type == "list") {
        this.$https
          .getPassApplyDetailsById({
            id: id
          })
          .then(({ data, code }) => {
            if (code != 200) {
              this.$toast("获取详情失败");
              return;
            }
            this.list = this.setInAndTime(data.passApplyUsers);
            // 默认全部审核

            this.auditList = data.passApprovals;
            // this.setShowNextAudit()
            // 判断是否显示审核按钮
            if (
              this.auditList.some(
                (item) =>
                  item.auditName ==
                  JSON.parse(localStorage.getItem("userInfo")).name
              )
            ) {
              let num = this.auditList.findIndex(
                (item) =>
                  item.auditName ==
                  JSON.parse(localStorage.getItem("userInfo")).name
              );
              this.isShowAuditBtn =
                this.auditList[num].auditStatus != 0 ? false : true;
              console.log("this.isShowAuditBtn", this.isShowAuditBtn);
            }
          });
      } else if (this.type == "au") {
        this.$https
          .getPassApplyDetailsById({
            id: id,
            auditId: JSON.parse(localStorage.getItem("userInfo")).id,
          })
          .then(({ data, code }) => {
            if (code != 200) {
              this.$toast("获取详情失败");
              return;
            }
            this.list = this.setInAndTime(data.passApplyUsers);
            // 默认全部审核

            this.auditList = data.passApprovals;
            // this.setShowNextAudit()
            // 判断是否显示审核按钮
            if (
              this.auditList.some(
                (item) =>
                  item.auditName ==
                  JSON.parse(localStorage.getItem("userInfo")).name
              )
            ) {
              let num = this.auditList.findIndex(
                (item) =>
                  item.auditName ==
                  JSON.parse(localStorage.getItem("userInfo")).name
              );
              this.isShowAuditBtn =
                this.auditList[num].auditStatus != 0 ? false : true;
              console.log("this.isShowAuditBtn", this.isShowAuditBtn);
            }
          });
      } else if (this.type == "user") {
         this.$https
          .getPassUserDetailsById({
            id: id
          })
          .then(({ data, code }) => {
            if (code != 200) {
              this.$toast("获取详情失败");
              return;
            }
            data.passApplyUsers&&(this.list = this.setInAndTime(data.passApplyUsers));
            // 默认全部审核

            this.auditList = data.passApprovals;
            // this.setShowNextAudit()
            // 判断是否显示审核按钮

            if (!this.auditList) return

            if (
              this.auditList.some(
                (item) =>
                  item.auditName ==
                  JSON.parse(localStorage.getItem("userInfo")).name
              )
            ) {
              let num = this.auditList.findIndex(
                (item) =>
                  item.auditName ==
                  JSON.parse(localStorage.getItem("userInfo")).name
              );
              this.isShowAuditBtn =
                this.auditList[num].auditStatus != 0 ? false : true;
              console.log("this.isShowAuditBtn", this.isShowAuditBtn);
            }
          });
      }
    },
    cancel() {
      this.pickerItem = {};
      this.remark = "";
    },
    handleSelIntervieweeItem(item) {
      console.log("item", item);
      this.pickerItem = item;
    },
    confirm() {
      // console.log(this.pickerItem,this.remark)
      // return
      let req = {
        auditId: JSON.parse(localStorage.getItem("userInfo")).id,
        id: this.id,
        nextAuditId: this.pickerItem.id,
        nextAuditName: this.pickerItem.name,
        passUserIds: this.auditIdList,
        remark: this.remark,
      };
      //  调用批量审批 接口
      this.$https.auditInAndOutApply(req).then((res) => {
        console.log("res", res);
        if (res.code == 200) {
          this.$toast("审批通过");
          // 刷新页面
          this.getAuditDetail();
        }
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.leave-form-wrap {
  padding-top: 1rem;
  padding-bottom: 4rem;
  position: relative;
  //   height: 100vh;
  //   overflow: hidden;
  .handle_btn {
    display: flex;
    position: fixed;
    right: 1rem;
    padding: 1rem 0;
    left: 1rem;
    bottom: 0;
    // background-color: #fff;
    justify-content: space-between;
    .van-button {
      flex: 1;
    }
  }
}

.form-wrap {
  display: flex;
  justify-content: space-between;
  margin: 0 1rem 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
  align-items: flex-start;
  // padding: 0.5rem 1rem;
  // .checkbox {
  //   padding-top: 0.6rem;
  //   flex: 1;
  // }
  .form_wrap_item {
    flex: 1;
    background-color: #fff;
    .form_wrap_item_con-title {
      display: flex;
      justify-content: space-between;
      padding: 0.5rem 1rem;
      font-size: 0.8rem;
      color: #c7c7c7;
      background-color: #ffff;
      border-bottom: 1px solid #e3e3e3;
      .title_tip {
        border: solid 1px #1b88f9;
        color: #1b88f9;
        padding: 0 5px;
        border-radius: 5px;
      }
    }
    .form_wrap_item_con {
      padding: 0.5rem 0;
      margin: 0 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.8rem;
      color: #c7c7c7;
      background-color: #fff;
      border-bottom: 1px dashed #e3e3e3;
      .info_span {
        font-size: 0.8rem;
        color: #474747;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem;
  border-radius: 0.75rem;
  .title {
    color: rgba(120, 132, 158, 1);
    font-size: 0.85rem;
    padding: 0.6rem 1.25rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
  }
  .panel {
    /* display: flex; */
    /* padding: 0rem 1rem 1rem 1rem; */
    .state {
      &.success {
        color: rgb(28, 196, 28);
      }
      &.reject {
        color: rgb(221, 40, 40);
      }
    }
    padding-top: 1rem;
    margin: 0 1rem;
    padding-bottom: 1rem;
    /* align-items: center; */
    img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }
    .info {
      flex: 1;
      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }
      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }
    .cell {
      padding: 0.5rem 0;
      color: #454f63;
      font-size: 0.875rem;
      display: flex;
      .headline {
        display: inline-block;
        color: #78849e;
        font-size: 0.75rem;

        margin-right: 1rem;
        width: 4rem;
        text-align: right;
      }
    }
  }
}
.dialog-wrap {
  padding: 10px;
}
.dialog-item-title {
  color: #78849e;
  font-size: 12px;
  margin: 10px 0;
}
.cell-wrap {
  background: #f7f7fa;
  padding: 10px 15px;
  border-radius: 20px;
  height: 38px;
  width: 100%;
  border: none;
}
</style>
